// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2jV-v","label":"Section_label__A8vqN","contentWrap":"Section_contentWrap__X2k2l","footer":"Section_footer__3EHQX","footerInner":"Section_footerInner__1xzS0"};